import React from 'react'
import { Col } from 'react-bootstrap'
import moment from 'moment'

import { DATE_CHECKIN_FORMAT } from 'constants.js'
import { dateFormatter } from 'Utils/Formatters'
import { Section, SectionLabel, SectionRow } from 'Components/Section'
import Button from '@material-ui/core/Button'

import { ProfilePicture } from './style'
import ConfirmableTimePicker from './../../../../Components/Form/ConfirmableTimePicker'
import { processDate } from 'Utils/Date'
import { getBAName } from '../../../../Utils/User'
import { authorization } from '../../../../Module/Auth/Auth'
import { LinkExternal } from '../../../../Components/LinkExternal'

const getMissionDuration = (checkInTime, checkoutTime) => {
  if (!checkInTime || !checkoutTime) return '-'
  const checkIn = moment(processDate(checkInTime))
  const checkOut = moment(processDate(checkoutTime))
  if (!checkIn.isValid() || !checkOut.isValid()) return '-'
  const diff = checkOut.diff(checkIn)
  if (diff < 0) return '-'
  const duration = moment.duration(diff)
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()
  return `${hours}h ${minutes}m`
}

const MissionAmbassador = ({
  mission,
  onCheckInTimeChange,
  onCheckOutTimeChange,
  onNotifyMissionWasSpied,
  isLoading,
}) => {
  const isSpyRole = authorization.isSpy()
  const showNotifyButton =
    authorization.isAdmin() || isSpyRole || authorization.isCityManager()

  const colWidth = 4

  const openBaPage = () =>
    window.open(
      `/dashboard/cities/${mission.city.id}/ambassadors/${mission.user.id}`,
      '_blank',
    )

  const baName = getBAName({
    firstName: mission.user.firstName,
    lastName: mission.user.lastName,
    isTeamLeader: mission.user.isTeamLeader,
  })

  return (
    <Section title={'Brand Ambassador'}>
      <SectionRow>
        <Col xs={colWidth} cypress_id="ba-name-in-brand-ambassador-section">
          <SectionLabel>Full Name</SectionLabel>
          {!isSpyRole ? (
            <LinkExternal onClick={openBaPage}>
              {getBAName({
                firstName: mission.user.firstName,
                lastName: mission.user.lastName,
                isTeamLeader: mission.user.isTeamLeader,
              })}
            </LinkExternal>
          ) : (
            baName
          )}
        </Col>
        {!isSpyRole ? (
          <Col xs={colWidth} cypress_id="mission-details-pay-ratio-div">
            <SectionLabel>Pay Ratio</SectionLabel>
            {mission.payoutRatio !== null && `${mission.payoutRatio} %`}
          </Col>
        ) : (
          <Col xs={colWidth} />
        )}
        <Col xs={colWidth} cypress_id="mission-details-checkin-date-time-div">
          <SectionLabel>Checkin</SectionLabel>
          {onCheckInTimeChange ? (
            <ConfirmableTimePicker
              pickerId="checkInTime"
              pickerName="Check In Time"
              pickerValue={processDate(mission.checkInTime)}
              minutesStep={1}
              onChange={onCheckInTimeChange}
              dialogTitle={mission.checkin.dialogTitle}
              initialDate={mission.recommendedCheckInTime.from}
            />
          ) : mission.checkInTime ? (
            dateFormatter(processDate(mission.checkInTime), DATE_CHECKIN_FORMAT)
          ) : (
            '-'
          )}
        </Col>
      </SectionRow>
      <SectionRow>
        <Col xs={colWidth}>
          <ProfilePicture src={mission.user.profilePicture} />
        </Col>
        {!authorization.isClient() &&
        !authorization.isClientAdmin() &&
        !isSpyRole ? (
          <Col xs={colWidth} cypress_id="mission-details-pay-adjust-reason-div">
            <SectionLabel>Pay Adjustment Reason</SectionLabel>
            {mission.payoutRatioComment !== null
              ? mission.payoutRatioComment
              : '-'}
          </Col>
        ) : (
          <Col xs={colWidth} />
        )}
        <Col xs={colWidth} cypress_id="mission-details-checkout-date-time-div">
          <SectionLabel>Checkout</SectionLabel>
          {onCheckOutTimeChange ? (
            <ConfirmableTimePicker
              pickerId="checkOutTime"
              pickerName="Check Out Time"
              pickerValue={processDate(mission.checkoutTime)}
              minutesStep={1}
              onChange={onCheckOutTimeChange}
              dialogTitle={mission.checkout.dialogTitle}
              initialDate={mission.recommendedCheckInTime.from}
            />
          ) : mission.checkoutTime ? (
            dateFormatter(
              processDate(mission.checkoutTime),
              DATE_CHECKIN_FORMAT,
            )
          ) : (
            '-'
          )}
        </Col>
      </SectionRow>
      <SectionRow>
        <Col xs={colWidth} />
        <Col xs={colWidth} />
        <Col xs={colWidth} cypress_id="mission-details-duration-div">
          <SectionLabel>Mission Duration</SectionLabel>
          {getMissionDuration(mission.checkInTime, mission.checkoutTime)}
        </Col>
      </SectionRow>
      {showNotifyButton && onNotifyMissionWasSpied && (
        <SectionRow thin={'true'}>
          {!isSpyRole ? (
            <Col xs={12}>
              {mission.notifiedSuccessfullySpied ? (
                'Notified successfully spied ✅'
              ) : (
                <Button
                  variant="contained"
                  onClick={onNotifyMissionWasSpied}
                  disabled={isLoading}
                >
                  Notify successfully spied
                </Button>
              )}
            </Col>
          ) : (
            <Col xs={colWidth} />
          )}
        </SectionRow>
      )}
    </Section>
  )
}

export { MissionAmbassador }
